import { getLabelMessage } from '@gef-ui/localization/messages';
import GenericDialog from '@gef-ui/material/components/Dialog/GenericDialog';
import PropTypes from 'prop-types';
import React from 'react';
import { errorPropType } from '../../constants';
import { useDefaultComponentValue } from '../../utils';
import { LogoutButton } from '../ActionButtons';
import Error from '../Error';
const COMPONENT_NAME = 'MuiModalError';
const ModalError = (inProps)=>{
    const props = useDefaultComponentValue({
        name: COMPONENT_NAME,
        inProps
    });
    const { error, onRefreshError, onCloseModal, actionButton, withSendOption, ...other } = props;
    if (!error) {
        return null;
    }
    const ContentComponent = error?.components?.Content ? error.components.Content : Error;
    const dialogProps = error?.components?.dialogProps ? error?.components?.dialogProps : {};
    return /*#__PURE__*/ React.createElement(GenericDialog, {
        withCross: error.unclosable ? undefined : !!onCloseModal,
        fullWidth: true,
        maxWidth: "lg",
        title: `${getLabelMessage('common:error').toUpperCase()}: ${error?.heading}`,
        onExit: error.unclosable ? undefined : onCloseModal,
        CrossButtonProps: {
            id: 'close-error-cross'
        },
        content: /*#__PURE__*/ React.createElement(ContentComponent, {
            hideHeading: true,
            error: error,
            onRefresh: error.unclosable ? undefined : onRefreshError,
            withSendOption: withSendOption,
            actionButton: error.unclosable ? /*#__PURE__*/ React.createElement(LogoutButton, null) : actionButton
        }),
        ...other,
        ...dialogProps
    });
};
ModalError.displayName = 'ModalError';
ModalError.propTypes = {
    actionButton: PropTypes.node,
    error: errorPropType,
    /**
	 * Passing this function makes cross icon appear in the top-right corner
	 */ onCloseModal: PropTypes.func,
    onRefreshError: PropTypes.func,
    withSendOption: PropTypes.bool
};
export default ModalError;
